function toggleVariantForm() {
    const formSelectVariant = document.getElementById("variantSelectorForm")
    const variantInfo = document.getElementById("variantInfo")
    formSelectVariant.classList.toggle("hidden");
    variantInfo.classList.toggle("hidden");
}

function selectVariant() {
    const selectVehicle = document.getElementById("selectVehicle")
    const redirectUrl = selectVehicle.options[selectVehicle.selectedIndex].getAttribute("data-product-url")
    
    window.location.href = redirectUrl
}
